<template lang="pug">
.lesson
  CourseLesson(
    v-if="Object.keys(currentLesson).length !== 0 && !gettingLesson"
    :lesson="currentLesson"
    :hideControls="true"
  )

  .lesson__block

    BodyIsAdmin(
      v-if="isAdmin && viewRole === 'admin'"
      :isAdminProp="isAdmin"
    )

    BodyIsUser(v-else :viewRole="viewRole")
  Header(
    :isAdminProp="isAdmin"
    :viewRole.sync="viewRole"
  )
  SuccessFacultyModal
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Header from './layouts/Header/Header';
import BodyIsAdmin from './layouts/BodyIsAdmin';
import BodyIsUser from './layouts/BodyIsUser';
import CourseLesson from '@/views/Courses/Course/layouts/Lesson';
import SuccessFacultyModal from '@/views/Courses/components/SuccessFacultyModal';

export default {
  components: {
    Header,
    BodyIsAdmin,
    BodyIsUser,
    CourseLesson,
    SuccessFacultyModal
  },
  data: () => ({
    viewRole: 'admin'
  }),
  computed: {
    ...mapState('auth', {
      isAdmin: s => s.data.user.permissions.isAdmin
    }),
    ...mapState('coursesLesson', {
      lessons: s => s.data.lessons,
      course: s => s.data.course,
      currentLesson: s => s.data.currentLesson,
      gettingLesson: s => s.meta.gettingLesson,
      canSave: s => s.aside.meta.canSave,
      isOpen: s => s.aside.meta.isOpen
    })
  },
  mounted() {
    this.initData();
  },
  methods: {
    ...mapActions('coursesLesson', ['getLesson']),
    ...mapActions('coursesCourse', ['getCourseStats']),
    async initData() {
      await this.getLesson();
      if (!this.isAdmin) {
        this.getCourseStats(this.course.id);
      }
    }
  }
};
</script>
